import type { CSSProperties, ReactNode } from 'react'

type PhoneScreenshotFrameProps = {
  src: string
  alt: string
  className?: string
  imageClassName?: string
  imageStyle?: CSSProperties
  children?: ReactNode
}

type BrowserScreenshotFrameProps = {
  src: string
  alt: string
  className?: string
  imageClassName?: string
}

export function PhoneScreenshotFrame({
  src,
  alt,
  className = '',
  imageClassName = 'object-cover object-top',
  imageStyle,
  children,
}: PhoneScreenshotFrameProps) {
  return (
    <div className={`relative mx-auto w-full max-w-[18rem] ${className}`}>
      {children}
      <div className="relative rounded-[2.75rem] bg-gray-800/80 p-2.5 shadow-2xl shadow-indigo-950/60 ring-1 ring-white/10 backdrop-blur">
        <div className="relative overflow-hidden rounded-[2.25rem] bg-white">
          <img
            src={src}
            alt={alt}
            className={`aspect-[9/17] w-full ${imageClassName}`}
            style={imageStyle}
          />
          <div
            className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-white via-white/80 to-transparent"
            aria-hidden="true"
          />
        </div>
      </div>
    </div>
  )
}

export function BrowserScreenshotFrame({
  src,
  alt,
  className = '',
  imageClassName = 'object-cover',
}: BrowserScreenshotFrameProps) {
  return (
    <div
      className={`overflow-hidden rounded-2xl border border-gray-300 bg-white shadow-xl shadow-gray-900/10 ${className}`}>
      <div className="flex h-9 items-center gap-x-2 border-b border-gray-200 bg-gray-50 px-4">
        <span className="h-2.5 w-2.5 rounded-full bg-red-400" />
        <span className="h-2.5 w-2.5 rounded-full bg-yellow-400" />
        <span className="h-2.5 w-2.5 rounded-full bg-green-400" />
      </div>
      <img src={src} alt={alt} className={`aspect-[4/3] w-full ${imageClassName}`} />
    </div>
  )
}
